import { Modal } from '@/components';

interface SiteDeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function SiteDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
}: SiteDeleteConfirmModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="현장 삭제 확인"
      size="md"
      closeOnBackdropClick
    >
      <div className="p-6">
        <p className="text-gray-600 mb-6  ">
          이 현장을 삭제하시겠습니까? <br />
          삭제된 현장은 복구할 수 없습니다.
        </p>
        <div className="flex space-x-3">
          <button
            onClick={onConfirm}
            className="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg cursor-pointer whitespace-nowrap"
          >
            삭제
          </button>
          <button
            onClick={onClose}
            className="flex-1 border border-gray-300 text-gray-700 py-2 rounded-lg cursor-pointer whitespace-nowrap"
          >
            취소
          </button>
        </div>
      </div>
    </Modal>
  );
}
